import React from "react";
import { Container } from "react-bootstrap";

import InvalidLinkCard from "./InvalidLinkCard";
import SinglePageContainer from "./SinglePageContainer";

const InvalidLinkPage = (): JSX.Element => {
    return (
        <SinglePageContainer>
            <Container>
                <InvalidLinkCard />
            </Container>
        </SinglePageContainer>
    );
};

export default InvalidLinkPage;
